<template>
    <v-layout column>
        <v-layout>
        <top-info-panel >
            <v-flex xs12 md12 lg6 xl5 px-2  slot="content" >
                <h4>Extra velden</h4>
                <p>Extra velden zijn zelf gedefinieerde data velden die toegevoegd kunnen worden aan bijvoorbeeld een Assetgroep.
                    Stel voor dat je een Assetgroep "auto" hebt aangemaakt en dat je voor auto's een extra veld "kenteken" wilt opnemen.
                    Dit is mogelijk met het gebruik van extra velden.
                </p>
            </v-flex>
        </top-info-panel>
        </v-layout>        
        <v-layout wrap px-3 align-center justify-center class="inset">        
<!-- OVERVIEW CUSTOM FIELDS ------------------------------------------------------------------------------------>            
        <v-flex xs12 md12 lg6 xl5 pt-2 v-if="!showCustomFieldForm">           
            <v-widget title="Extra velden" class="" title-text-color="">
                <v-btn fab dark  color="accent" slot="button-top-right" @click="newCustomField()">
                    <v-icon dark>add</v-icon>
                </v-btn>  
                <v-layout slot="widget-content">
                    <v-flex xs12 mt-4>                                         
                        <v-text-field     
                            v-if="customFieldsPagination.total_pages"                       
                            @keyup="search(vm)"
                            v-model="searchMixin.searchText"
                            prepend-inner-icon="fas fa-search"
                            dense
                            label="Zoek een extra veld"
                            solo>                    
                        </v-text-field>
                        <v-pagination v-if="customFieldsPagination.total_pages"
                            v-model="customFieldsPagination.current_page"
                            :length="customFieldsPagination.total_pages"                           
                            @input="loadPage">
                        </v-pagination>                      

                        <v-data-table :headers="gridHeaders" :items="customFields" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr @click="selectCustomField(props.item)">
                                <td>{{ props.item.name }}</td>                            
                                <td>{{ props.item.type.name}}</td>
                                <td>{{ isProtected(props.item.protected)}}</td>
                            </tr>
                        </template>
                        </v-data-table>    
                        <v-pagination v-if="customFieldsPagination.total_pages"             
                            v-model="customFieldsPagination.current_page"
                            :length="customFieldsPagination.total_pages"                           
                            @input="loadPage">
                        </v-pagination>                            
                    </v-flex>                                          
                </v-layout>
            </v-widget>
        </v-flex>
<!-- FORM CUSTOM FIELDS ---------------------------------------------------------------------------------------->        
        <v-flex xs12 md12 lg6 xl5 pt-2 v-if="showCustomFieldForm">           
            <v-widget :title="`Extra veld: ${mode} `" class="" title-text-color="">
                <v-layout slot="widget-content">
                    <custom-field-form
                        @saved="customFieldSaved"
                        @cancelClicked="backToOverview()"
                        :customField="selectedCustomField"
                    >
                    </custom-field-form>
                </v-layout>
            </v-widget>
        </v-flex>        
        </v-layout>
    </v-layout>
</template>

<script>
    import * as types from "../../store/types"
    import { mapGetters } from "vuex"
    import VWidget from "../../components/global/VWidget"
    import TopInfoPanel from '../../components/global/TopInfoPanel'    
    import CustomFieldForm from '../../components/customFields/CustomFieldForm'    
    import SearchMixin from '../../plugins/mixins/SearchWithPagerMixin'

    export default {
        mixins:[SearchMixin],
        data() {
            return {
                compObj:this,
                searchText:"",
                currentPage:1,
                gridHeaders: [
                    { text: "Naam", sortable: false },
                    { text: "Type", sortable: false },
                    { text: "Aanpasbaar", sortable: false },                    
                ],                
                showCustomFieldForm:false,
                selectedCustomField: null
            }
        },
        computed: {
            ...mapGetters({
                customFields: types.CUSTOM_FIELDS,
                customFieldsPagination: types.CUSTOM_FIELDS_PAGINATION
            }),
            mode(){
                
                return this.selectedCustomField ? this.selectedCustomField.name : "Nieuw"
            }
        },
        methods: {
            isProtected(bool){
                return !bool ? "Ja" : "Nee"
            },
            newCustomField() {
                this.selectedCustomField=null
                this.showCustomFieldForm=true
            },
            selectCustomField(cf){          

                if(cf.protected){
                    this.$notify(`Veld '${cf.name}' is niet aanpasbaar`, {type: 'error', icon: 'times'})         
                }
                else{
                    // add customFieldTypeId 
                    cf.customFieldTypeId = cf.type.id  
                    this.selectedCustomField = cf
                    this.showCustomFieldForm=true
                }
            },
            customFieldSaved(cf){                
                this.backToOverview()  
                this.loadCustomFields()
            },
            backToOverview(){
                this.selectedCusomField=null
                this.showCustomFieldForm=false                
            },
            loadCustomFields(){
                this.loadPage(1)                            
            }            
        },
        mounted(){
            // configure mixin
            this.searchMixin.payloadData     = {}
            this.searchMixin.payloadIncludes = "type"
            this.searchMixin.searchStore     = types.CUSTOM_FIELD_SEARCH
            this.searchMixin.defaultStore    = types.CUSTOM_FIELDS            

            if(this.customFields.length==0){
                this.loadCustomFields()
            }	        
        },
        components:{
            TopInfoPanel,
            VWidget,
            CustomFieldForm
        }            
    }
</script>

<style scoped>

</style>